import React from 'react';
export function BonusStack() {
  const bonuses = [{
    num: 1,
    title: 'CÓDIGO DEL SILENCIO',
    value: '$27',
    image: 'https://cdn.magicpatterns.com/uploads/eJsnadM4CnMCZ61YAqjZ1h/fotobono1.png'
  }, {
    num: 2,
    title: 'EL INTERRUPTOR DE CORTISOL',
    value: '$17',
    image: 'https://cdn.magicpatterns.com/uploads/jHwQ7HkKmLiacFeHUXSHXj/fotobono2.png'
  }, {
    num: 3,
    title: 'GUÍA: CALMA EN EL ELEVADOR',
    value: '$17',
    image: 'https://cdn.magicpatterns.com/uploads/fMraebe9bYy3a1iGJKa9CZ/fotobono3.png'
  }, {
    num: 4,
    title: 'PLANTILLA DE SOS: CUANDO NADA FUNCIONA',
    value: '$12',
    image: 'https://cdn.magicpatterns.com/uploads/eJsnadM4CnMCZ61YAqjZ1h/fotobono1.png' // Reusing image 1 as placeholder for 4
  }];
  return <section className="py-10 px-4 bg-cloud-grey" data-id="element-8">
      <div className="max-w-4xl mx-auto" data-id="element-9">
        <div className="space-y-5 mb-8" data-id="element-10">
          {bonuses.map(bonus => <div key={bonus.num} className="bg-white rounded-[20px] shadow-md border border-gray-200 p-6 flex flex-col sm:flex-row items-center gap-6" data-id="element-11">
              <img src={bonus.image} alt={bonus.title} className="w-24 h-24 object-cover rounded-[12px] shadow-sm" data-id="element-12" />
              <div className="flex-1 text-center sm:text-left" data-id="element-13">
                <div className="inline-block bg-brand-gold text-white text-xs font-bold px-3 py-1 rounded-full uppercase tracking-wider mb-3" data-id="element-14">
                  Bono #{bonus.num} - GRATIS
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-15">
                  {bonus.title}
                </h3>
                <p className="text-gray-500 font-medium" data-id="element-16">
                  VALOR: <span className="line-through" data-id="element-17">{bonus.value}</span> →
                  HOY: <span className="text-green-600 font-bold" data-id="element-18">GRATIS</span>
                </p>
              </div>
            </div>)}
        </div>

        <div className="bg-brand-teal rounded-[20px] p-8 text-center shadow-xl border-4 border-brand-gold/20" data-id="element-19">
          <h3 className="text-2xl font-bold text-brand-gold mb-2" data-id="element-20">
            VALOR TOTAL DE ESTAS HERRAMIENTAS: $73.00 USD
          </h3>
          <p className="text-white text-lg" data-id="element-21">
            Hoy las recibes COMPLETAMENTE GRATIS con tu Método DOG-CALM™
          </p>
        </div>
      </div>
    </section>;
}